// TODO #1 iframe-resizer ESM
// - Is there a better way? Probably needs to eject the create-react-app.
// - https://webpack.js.org/loaders/exports-loader/
import 'iframe-resizer/js/iframeResizer.contentWindow';

import { IFramePageOptions, PageInfo } from 'iframe-resizer';

import { EventEmitter2, ListenerFn } from 'eventemitter2';

const emitter = new EventEmitter2();

let currentPageInfo: PageInfo | undefined;

// TODO #1 Doc: This must be set ass soon as possible and never change.
// TODO #1 Add targetOrigin for better security?
// - https://github.com/davidjbradshaw/iframe-resizer/blob/master/docs/iframed_page/options.md
const iFrameResizer: IFramePageOptions = {
  onMessage: message => {
    emitter.emit('message', message);
  },
  onReady: () => {
    const { parentIFrame } = window;
    emitter.emit('ready');
    parentIFrame.getPageInfo(pageInfo => {
      currentPageInfo = pageInfo;
      emitter.emit('pageInfo', pageInfo);
    });
  },
};

window.iFrameResizer = iFrameResizer;

// TODO #1 Improve EventEmitter2 fn mapping (all params, all types)
// TODO #1 Better name? iFrameResizerUtils, iFrameResizerEmitter
// TODO #1 Strict typing
// TODO #1 Convert this into helper which will provide all the iFrameResizer functionalities?
const iFrameResizerChild = {
  getCurrentPageInfo: (): PageInfo | undefined => currentPageInfo,
  off: (event: string, listener: ListenerFn): void => {
    emitter.off(event, listener);
  },
  on: (event: string, listener: ListenerFn): void => {
    emitter.on(event, listener);
  },
};

export default iFrameResizerChild;
